export default __webpack_public_path__ + "static/media/audio-2.af81e7d4.mp3";